import styled, { css } from 'styled-components';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
const sizeToIconSize = {
    '2xl': 56,
    xl: 48,
    lg: 40,
    md: 32,
    sm: 24,
    xs: 24,
    xxs: 24,
};
const sizeToLabelGap = {
    '2xl': 4,
    xl: 4,
    lg: 2,
    md: 2,
    sm: 2,
    xs: 2,
    xxs: 2,
};
const sizeToContainerGap = {
    '2xl': 'spacing.lg',
    xl: 'spacing.lg',
    lg: 'spacing.lg',
    md: 'spacing.lg',
    sm: 'spacing.md',
    xs: 'spacing.md',
    xxs: 'spacing.md',
};
function titlesOnSameLine(props) {
    if (props.$alignment !== 'horizontal') {
        return false;
    }
    if (props.$size === 'sm' || props.$size === 'xs' || props.$size === 'xxs') {
        return true;
    }
    return false;
}
export const Container = styled.div `
  display: flex;
  align-items: ${({ $alignment }) => ($alignment === 'vertical-left' ? 'flex-start' : 'center')};
  justify-content: center;
  gap: ${({ $alignment, $size }) => $alignment === 'horizontal' ? themeGet('spacing.md') : themeGet(sizeToContainerGap[$size])};
  flex-direction: ${({ $alignment }) => ($alignment === 'horizontal' ? 'row' : 'column')};
  text-align: ${({ $alignment }) => ($alignment === 'vertical' ? 'center' : 'start')};
  overflow: hidden;
`;
export const LabelContainer = styled.div `
  display: flex;
  flex-direction: ${(props) => (titlesOnSameLine(props) ? 'row' : 'column')};
  align-items: ${(props) => titlesOnSameLine(props) && 'baseline'};
  gap: ${({ $size }) => $size && pxToRem(sizeToLabelGap[$size])};
  min-width: 0;
`;
export const StyledTypography = styled(Typography) `
  ${(props) => props.$truncate &&
    css `
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`;
export const IconContainer = styled.div `
  [data-icon='falcon'],
  svg {
    display: block;
    width: ${(props) => pxToRem(sizeToIconSize[props.$size])};
    height: ${(props) => pxToRem(sizeToIconSize[props.$size])};
  }

  [data-icon='falcon'] {
    color: ${themeGet('colors.gray.800')};
  }
`;
